export default __webpack_public_path__ + "static/media/ledIcon.d1a9531b.svg";